import { trans } from '@lingoda/i18n';
import { NotificationBar } from '@lingoda/ui';

export const SprintNotificationBar = () => (
    <NotificationBar title={trans('build-a-habit', {}, 'student-notification')} />
);
